/**
 * @ngdoc controller
 * @name userMaintenanceModule.ViewDetailIntermediaryGroupDwtController
 * @description This controller is used for user maintenance module. This mainly
 *              deals with viewing details of particular issuer group.
 * @requires userGroupService is the service which is being used to interact
 *           with REST
 * @requires $scope,$stateParams for storing/passing information in scope/state
 * @requires $log mainly used for logging. Used only $log.debug and could be
 *           enabled/disabled based on need.
 */

angular.module('userMaintenanceDwtModule').controller(
  'ViewIntermediaryGroupDetailsDwtController',
  [
    '$scope',
    '$log',
    '$stateParams',
    '$sessionStorage',
    'userGroupService',
    function($scope, $log, $stateParams, $sessionStorage,
      userGroupService) {
      $scope.intermediaryId = $stateParams.groupId;
      $scope.prodType = $sessionStorage.productType;
      $scope.userGroupName = 'intermediary';
      userGroupService.getViewIntermediaryGroup($scope.intermediaryId,
        $scope.prodType, 'EN').query().$promise.then(function(
        data) {
        $scope.userGroupDetails = data;
        if (null !== $scope.userGroupDetails.logoBaseStr
                        && '' !== $scope.userGroupDetails.logoBaseStr) {
          $scope.showLogo = true;
        } else {
          $scope.showLogo = false;
        }
      }, function(error) {
        $log.debug(error);
      });
    }]);
